"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixRedHearts = fixRedHearts;
function fixRedHearts(tex) {
    return tex.replace(new RegExp(`\\\\red\\s*♥`, "g"), "\\red{♥}");
}
